export default __webpack_public_path__ + "static/media/b12-med.4983e3b7.jpg";